type Primitives = string | number | boolean | undefined

export function getArrayQueryParam(key: string, items: any[]): string {
  let result = items.reduce((acc, item) => `${acc}&${key}=${encodeURIComponent(item)}`, '') as string
  result = result.slice(1)
  return result
}

export function getQueryUrl<T extends Record<string, Primitives | Primitives[]>>(obj: T) {
  let url = ''
  for (const [key, value] of Object.entries(obj)) {
    if (value === undefined) continue
    const result = value
    if (result instanceof Array) {
      url += `&${getArrayQueryParam(key, result)}`
    } else {
      url += `&${key}=${encodeURIComponent(result)}`
    }
  }

  return url.slice(1)
}
